import {
  createStripeSubscriptionAction,
  getPricesLoader,
} from '@app-studio-web/ui/pages/checkout/checkoutRoutes'
import PlansPage from './PlansPage'

const checkoutRoutes = [
  {
    path: '',
    children: [
      {
        action: createStripeSubscriptionAction,
        element: <PlansPage />,
        loader: getPricesLoader,
        path: 'plans',
      },
    ],
  },
]

export default checkoutRoutes
